export default {
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    image: "/welcome/quiz_turkey_new_year_steps.jpg",
    title: "Fırsatlar sezonu devam ediyor! Çocuğunuz için süper fırsatlar!🎁",
    subtitle:
      "Yeni yıl zamanı başladı! Hediyenizi şimdi alın - çocuğunuz için 60 dakikalık ücretsiz dersi!😍",
    button: "Şimdi bir hediye alın!",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz için mükemmel hediyeyi buldunuz mu?",
      answers: [
        "🎉 Evet",
        "🤔 Hayır",
        "⌛️ Zamanım yoktu",
      ],
    },
    2: {
      question: "Önümüzdeki yıl çocuğunuzun bilgisini geliştirmek mi istiyorsunuz?",
      answers: [
        "📈 Elbette istiyorum",
        "👍 Çocuğum okulda harika gidiyor",
        "🙌 Henüz bu konuda düşünmedim",
      ],
    },
    3: {
      question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
      answers: [
        {
          answer: "💻 Evet",
          distribution_tag_question: [18],
        },
        {
          answer: "😐 Hayır",
          stopAnswer: true
        },
      ],
    },
    4: {
      title: "Deneme dersi için hangi saatte uygunsunuz?",
      type: "timeslot",
      subtitle:
        "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
      button: "Rezervasyon için tıklayın 🎁",
    },
    5: {
      question: "Önümüzdeki yıl çocuğunuzun hangi becerilerini geliştirmek istersiniz?",
      answers: [
        "😌 Yararlı yeni bir beceride ustalaşmak",
        "📱 Teknolojik aletlerdeki ekran süresini verimli hale getirin",
        "👍 Çocuğumun çalışma arzusuna sahip olmasını istiyorum",
        "🤔 Bilmiyorum, okul hakkında daha fazla bilgi edinmek istiyorum",
      ],
    },
    6: {
      title: "Çocuğunuz kaç yaşında?",
      type: "age",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz",
      button: "İleri 🚀",
    },
    7: {
      title: "Çocuğunuzun adı nedir?",
      type: "child_name",
      subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir 🚨",
      button: "İleri 🚀",
    },
    8: {
      title: "E-postanızı girin",
      type: "mail",
      subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
      button: "İleri 🚀",
    },
    9: {
      title: "Telefon numaranızı girin",
      type: "phone",
      subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
      button: "Neredeyse bitti 🔥",
    },
    10: {
      title: "İsminizi girin",
      type: "parent_name",
      subtitle: "Bizim adımız Kodland, sizinki ne?👋",
      button: "Son adım! 🎉",
    },
  },
};


